<template lang="pug">
  svgicon(:name="name" :fill="fill" :original="original" :class="{ [$options.name]: true, 'default-size': defaultSize }")

</template>

<script>
  export default {
    name: "mr-icon",

    props: {
      name: {
        type: String,
        required: true,
      },
      // color: {}, DO NOT use color here. By using hex code here we are
      // hard coding the color in the vue template, we should use css variables only
      // and for that reason the color should be set via css
      fill: {
        type: Boolean,
        default: true
      },

      original: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      defaultSize() {
        return !(this.$attrs.height);
      }
    },

    created() {
      // The `[request]` placeholder is replaced
      // by the filename of the file which is
      // loaded (e.g. `mr-icon-zoom-in.js`).
      import(/* webpackChunkName: "mr-icon-[request]" */ `../mr-icons/${this.name}`);
    }

  };
</script>

<style lang="stylus">
  .mr-icon
    display inline-block
    color inherit
    vertical-align middle
    fill none
    stroke currentColor

    &.default-size
      width 1em

  .mr-icon-fill
    fill currentColor
    stroke none

</style>